import React from "react";
import {
  Container,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Link,
} from "@mui/material";

const DeleteAccount = () => {
  return (
    <Container>
      <Typography variant="h4" component="h1" gutterBottom>
        Eliminación de Cuenta
      </Typography>
      <Typography variant="body1" paragraph>
        Bienvenido a la página de eliminación de cuenta de{" "}
        <strong>GerenUC</strong>. Si deseas eliminar tu cuenta y todos los datos
        asociados, sigue las instrucciones a continuación.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom>
        Pasos para Solicitar la Eliminación de la Cuenta
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="1. Inicia sesión en tu cuenta de GerenUC." />
        </ListItem>
        <ListItem>
          <ListItemText primary="2. Ve a la sección de Perfil en la aplicación." />
        </ListItem>
        <ListItem>
          <ListItemText primary="3. Haz clic en el botón 'Eliminar cuenta' al final de la página del perfil." />
        </ListItem>
        <ListItem>
          <ListItemText primary="4. Confirma que deseas eliminar tu cuenta en el mensaje de confirmación." />
        </ListItem>
      </List>
      <Typography variant="body1" paragraph>
        También puedes enviar una solicitud de eliminación de cuenta por correo
        electrónico a{" "}
        <Link href="mailto:team-green@denwaip.com">team-green@denwaip.com</Link>{" "}
        con el asunto "Solicitud de eliminación de cuenta".
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom>
        Tipos de Datos que se eliminan
      </Typography>
      <Typography variant="body1" paragraph>
        Al eliminar tu cuenta, se eliminarán los siguientes datos:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="• Información de perfil (nombre, apellido, foto de perfil)." />
        </ListItem>
        <ListItem>
          <ListItemText primary="• Dirección de correo electrónico." />
        </ListItem>
      </List>

      <Typography variant="body1" paragraph>
        Para más información, por favor contacta a nuestro soporte técnico en{" "}
        <Link href="mailto:team-green@denwaip.com">team-green@denwaip.com</Link>
        .
      </Typography>
    </Container>
  );
};

export default DeleteAccount;
